import { Stack } from "@chakra-ui/react";
import type { BuyerPublicBidDetailDto } from "../../../../autogen/bff-api";
import { BidActivityTimeline } from "./BidActivityTimeline";
import { BidContactCard } from "./BidContactCard";
import { QualificationProgressCard } from "./QualificationProgressCard";

interface Props {
  detail: BuyerPublicBidDetailDto;
  onOpenQualifications: () => void;
}

export const BidDetailSidebar = ({ detail, onOpenQualifications }: Props) => (
  <Stack spacing="4">
    <BidContactCard detail={detail} />
    <QualificationProgressCard detail={detail} onOpenQualifications={onOpenQualifications} />
    <BidActivityTimeline detail={detail} />
  </Stack>
);
